import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { observer, Observer } from 'mobx-react';
import styled from 'styled-components';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';


import { Container } from '../../../libs/base/base-style';
import { useHorsesStore } from '../../../stores/horses'
import { useHistory } from 'react-router-dom';
import HorseList from './HorseList'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const App: FunctionComponent = (props) => {
    const stores = useHorsesStore()
    const route = useHistory()
    const usrId = useMemo(() => {
        if (process.env.NODE_ENV == 'production') {
            return window.reactPress?.user.data.ID
        } else {
            return '1'
        }
    }, [])

    useEffect(() => {
        if (usrId) {
            stores.list(usrId)
            stores.getAvailableHosres(usrId)
            stores.checkMembershipValid()
        }

    }, [])

    return <Observer>{() => <Wrapper>

        {usrId ? stores.checking == false ? stores.membershipValid == true ? <HorseList /> : <ErrorPage /> :
            <Box alignContent={'center'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
                <Skeleton animation="wave" height={10} width="30%" style={{ marginBottom: 6 }} />
                <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} width="40%" />
                <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" width="40%" />
            </Box> : <MsgModal />
        }

    </Wrapper>}</Observer>
}

const Wrapper = styled(Container)`
    padding:20px;
    display:flex;
    flex:1;
    flexDirection:column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height:600px;
    width:100%;
    height:100%;
    display:inline-table;
`
const styles = { padding: '8px !important', backgroundColor: 'initial !important', height: '25px', color: '#fff !important', background: ' #408697 !important', fontSize: '10px !important', borderRadius: 0 }
function MsgModal() {
    const route = useHistory()
    return (
        <MsgWrapper
        >
            <Typography variant='h2' mb={5}>
                {"Sorry, You are not logged in."}
            </Typography>
            <Typography variant='h5'>
                EquiManage is a new feature that allows you to record your own horse's details.
            </Typography>
            <Typography variant='h5' >
                You can record vet, farrier, dentist etc. visits, as well as feed regimes, treatments given, work done / training and your results.
            </Typography>
            <Typography variant='h5' >
                You can also store contact details for your farrier, vet, trainer etc. and request visits straight from the program.
            </Typography>
            <Typography variant='h5' mb={2}>
                A calendar also allows you to keep track of all upcoming / past visits.
            </Typography>
            <Button onClick={() => {
                route.push('login')
            }} sx={styles}>Login</Button>
            <Typography variant='body2' margin={1}>
                {"Or"}
            </Typography>
            <a href="/create-an-account">Create an account</a>
        </MsgWrapper>
    );
}

function ErrorPage() {
    return (
        <MsgWrapper
        >
            <Typography variant='h2' mb={20} maxWidth={'800px'} align='center'>
                <strong><a href="/create-an-account">Become a member</a></strong> and get full features. If your account subscription has expired, please <strong><a href="/my-account/subscriptions">renew</a></strong> it first.
            </Typography>

        </MsgWrapper >
    );
}
const MsgWrapper = styled(Box)`
    display:flex;
    flex:1;
    flex-direction:column;
    align-items: center;
    justify-content:center;
    width:100%;
    height:100%;
`

export default observer(App)